import React from "react"; 
import PropTypes from "prop-types";
import { ItemPropType } from "../../PropTypes";
import { connect } from "react-redux";
import { selectors } from "../../app/slices/itemSlice";
import { Duration } from "luxon";

function ThankYouModal(props) {
  const { REACT_APP_CORPORATE_SITE_PROFILE_BASEURL } = process.env;
  const {
    item,
    user,
    closeRootModal
  } = props;

  let hasProfilePageLink = false;
  let thanksMessage = item.implementation.thanksMessage;
  let splitThanksMessage = "";

  let username = user.isOrganisation
    ? user.organisationName.split(" ").join("")
    : user.firstName + user.lastName;

  if (thanksMessage.includes("{moderationTime")) {
    thanksMessage = thanksMessage.replace(
      "{moderationTime}",
      Duration.fromObject({
        minutes: item.implementation.moderationTimeInMinutes,
      }).toFormat("hh")
    );
  }

  if (thanksMessage.includes("{profilePage}")) {
    hasProfilePageLink = true;
    splitThanksMessage = thanksMessage.split("{profilePage}");
  }

  return (
    <div className="ugc-contribution-modal--thank-you-container">
      <h2 className="h3 ugc-contribution-modal--thank-you-container-title">
        Thank you
      </h2>
      {hasProfilePageLink === true ? (
        <p>
          {splitThanksMessage[0]}
          <a
            href={`${REACT_APP_CORPORATE_SITE_PROFILE_BASEURL}/${user.memberId}/${username}`}
          >
            profile page
          </a>
          {splitThanksMessage[1]}{" "}
        </p>
      ) : (
        <p>{thanksMessage} </p>
      )}
      <div className="modal__buttons-wrapper ugc-contribution-modal--thank-you-close">
        <button className="govuk-button he-button he-button__primary"
                onClick={closeRootModal}>
          Close
        </button>
      </div>
    </div>
  );
}

ThankYouModal.propTypes = {
  closeRootModal: PropTypes.func,
  item: ItemPropType,
};

const mapStateToProps = (state) => {
  return { item: selectors.item(state), user: selectors.user(state) };
};

export default connect(mapStateToProps, null)(ThankYouModal);
